export const formatDate = (date: string) => {
    if (!date) {
        return "";
    }
    return date.split("-")[2].padStart(2, "0") + "/" + date.split("-")[1].padStart(2, "0") + "/" + date.split("-")[0];
};

export function formatDateToDDMMYYYY(dateString: string, showTime: boolean = false): string {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        return ''; // Data inválida
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    if (showTime) {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${formattedDate} ${hours}:${minutes}:${seconds}`;
    }

    return formattedDate;
}
